import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

export interface ProgressBarModel {
  showProgressbar: boolean;
  maxValue: number;
  actualValue: number;
  progressInPercent: number;
  errors:string[];
}

@Injectable({
  providedIn: 'root'
})

export class ProgressbarService {

  private loadingSubject:BehaviorSubject<ProgressBarModel> = new BehaviorSubject<ProgressBarModel>({
    showProgressbar: false,
    maxValue:0,
    actualValue:0,
    progressInPercent: 0,
    errors:[]
  });

  loading$ = this.loadingSubject.asObservable();

  constructor() { }

  startShowProgressbar(maxValue:number) {
    const progressBarModel = {
      showProgressbar: true,
      maxValue: maxValue,
      actualValue: 0,
      progressInPercent: 0,
      errors: []
    }
    this.loadingSubject.next(progressBarModel);
  }

  onLoading(newValue: number) {
    const oldProgressBarModel = this.loadingSubject.getValue();
    const progressBarModel = {
      showProgressbar: true,
      maxValue: oldProgressBarModel.maxValue,
      actualValue: newValue,
      progressInPercent: newValue/oldProgressBarModel.maxValue * 100,
      errors: oldProgressBarModel.errors
    }
    this.loadingSubject.next(progressBarModel);
  }

  onError(error:string) {
    const oldProgressBarModel = this.loadingSubject.getValue();
    oldProgressBarModel.errors.push(error);

    this.loadingSubject.next(oldProgressBarModel);

  }

  stopShowProgressbar() {
    const oldProgressBarModel = this.loadingSubject.getValue();

    const newProgressBarModel = {
      showProgressbar: false,
      maxValue: oldProgressBarModel.maxValue,
      actualValue: oldProgressBarModel.actualValue,
      progressInPercent: oldProgressBarModel.progressInPercent,
      errors: oldProgressBarModel.errors
    }
    this.loadingSubject.next(newProgressBarModel);
  }
}
